import { utils } from '../utils/utils';
import { HttpClient } from './serviceBase';

class AdjustmentTypesService {
    SearchAdjustmentTypes = async (pageSize, pageNumber, filters) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            pageSize,
            pageNumber
        })

        return await HttpClient.Get(`/api/AdjustmentTypes/search?${queryString}`);
    }

    GetAdjustmentTypesById = async (adjustmentTypesId) =>
        await HttpClient.Get(`/api/AdjustmentTypes/${adjustmentTypesId}`);

    GetAdjustmentTypes = async () =>
        await HttpClient.Get(`/api/AdjustmentTypes/adjustmentTypes`);
}

export default new AdjustmentTypesService();